<template>
    <section>
        <v-overlay v-if="isFakeOrder">
          <h2 class="display-1">{{ $t('fakeOrderText') }}</h2>
        </v-overlay>
        <section v-if="isLoading">
          <SkeletonLoaderModule />
        </section>
        <section v-else>
          <Hero v-if="order" :sumEmissions="sumEmissions"/>
          <CompanyInfo
            v-if="order"
            :clientName="order.client_name"
            :verifyId="order.verify_id"
            :clientLogo="order.client_logo"
            :city="getCityFromBillingProfile"
            :orderItems="order.order_items"
          />
          <CertificatePreview :orderItems="order.order_items"/>
          <template v-for="(project, index) in aggregatedProjects" >
            <ProjectItem :project="project" :index="index" :key="index"/>
          </template>

          <!--<ContactBadge />-->
        </section>

        <Footer />
    </section>
</template>
<i18n>
{
  "en" : {
    "fakeOrderText": "Draft Sample Order"
  },
  "de": {
    "fakeOrderText": "Entwurf Musterauftrag"
  }
}
</i18n>
<script>
import axios from 'axios';
import API_URLS from '@/api/urls';
import Hero from '@/components/Hero.vue';
import CompanyInfo from '@/components/CompanyInfo.vue';
import CertificatePreview from '@/components/CertificatePreview.vue';
import ProjectItem from '@/components/ProjectItem.vue';
import SkeletonLoaderModule from '@/components/SkeletonLoaderModule.vue';
import Footer from '@/components/Footer.vue';
// import ContactBadge from '@/components/ContactBadge.vue';

export default {
  name: 'Tracking',
  components: {
    Hero,
    CompanyInfo,
    CertificatePreview,
    ProjectItem,
    SkeletonLoaderModule,
    Footer,
    // ContactBadge,
  },
  data() {
    return {
      order: null,
      isLoading: true,
      hasError: false,
      isFakeOrder: false,
    };
  },
  computed: {
    getCityFromBillingProfile() {
      if (this.order.order_items[0].billing_profile) {
        return this.order.order_items[0].billing_profile.city;
      }
      return '';
    },
    sumEmissions() {
      let sum = 0.00;
      this.order.order_items.forEach((orderItem) => {
        sum += parseFloat(orderItem.emissions);
      });
      return sum;
    },
    aggregatedProjects() {
      const projects = [];
      this.order.order_items.forEach((orderItem) => {
        projects.push(orderItem.project);
      });
      const aggregatedProjects = projects.filter((v, i, a) => a.findIndex((t) => (t.uuid === v.uuid)) === i);
      return aggregatedProjects;
    },
  },
  created() {
    this.isLoading = true;

    const headers = {
      Authorization: `Token ${process.env.VUE_APP_API_TOKEN}`,
      'Content-Type': 'application/json',
    };

    axios.get(`${API_URLS.GET_ORDER + this.$route.params.verifyId}/`, { headers })
      .then((response) => {
        this.order = response.data;
        if (this.order.is_fake_order) {
          this.isFakeOrder = true;
        }
        this.isLoading = false;
      })
      .catch((e) => {
        console.error('Error loading order data', e);
        if (e.response.status === 404) {
          console.log('404');
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'ServerError' });
        }
        this.isLoading = false;
        this.hasError = true;
      });
  },
};
</script>

<style lang="scss" scoped>
.loadingContainer {
    height: 100vh;
    text-align: center;
}

.hero-loader {
  height: 80vh;
}
</style>
